import { BodyText, Spinner, Stack } from '@servicetitan/design-system';

/**
 * A simple component that displays a spinner and a text that says "Connecting...".
 * @returns A spinner and a text that says "Connecting..."
 */
const ConnectingIndicator = ({ text }: { text?: string }) => {
  return (
    <Stack spacing={'1'}>
      <Spinner size={'tiny'} />
      <BodyText size={'small'} bold>
        {text || 'Connecting...'}
      </BodyText>
    </Stack>
  );
};

export default ConnectingIndicator;
